<template>
    <v-modal :width="420" :visible="visible" @cancel="cancel">
        <div class="success-modal color-dark-1 txt-c">
            <i class="iconfont icon-chenggong"></i>
            <div class="font-size-24 margin-top-30">{{ title }}</div>
            <a v-if="msgType === 'changePass'" class="display-ib font-size-14 color-blue margin-top-10" @click="cancel">{{ changePassMsg }}</a>
            <div v-else class="font-size-14 margin-top-10">{{ msg }}</div>
        </div>
        <div slot="footer" class="txt-c"></div>
    </v-modal>
</template>

<script>
import mixins from '@/configs/mixins';

const initData = () => ({
    visible: false,
    title: '修改成功',
    msgType: '',
    msg: '恭喜您，修改成功',
    changePassMsg: ''
});

let timer = null;

export default {
    name: 'SuccessModal',
    mixins: [mixins],
    destroyed() {
        clearInterval(timer);
    },
    data() {
        return initData();
    },
    watch: {
        visible(value) {
            if (value && this.msgType === 'changePass') {
                let seconds = 3;

                this.updateState({ changePassMsg: `${seconds} S后返回首页` });
                timer = setInterval(() => {
                    seconds -= 1;

                    if (seconds === 0) {
                        clearInterval(timer);
                        this.cancel();
                    } else {
                        this.updateState({ changePassMsg: `${seconds} S后返回首页` });
                    }
                }, 1000);
            }
        }
    },
    methods: {
        cancel() {
            if (this.msgType === 'changePass') {
                this.$pub.toIndex();
            }

            this.updateState(initData());
        },
    }
};
</script>

<style scoped lang="less">
.success-modal {
    padding: 83px 0 47px 0;
    .iconfont {
        font-size: 40px;
        line-height: 1;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SuccessModal/SuccessModal.vue